define('views/pages/trade/offer/repeat/table',[
    'jquery',
    'underscore',
    'mediator',
    'views/base/view',
    'views/base/collection',
    'lib/utils',

    'text!templates/pages/trade/offer/repeat/table.ejs',
    'text!templates/pages/trade/offer/repeat/table-row.ejs'

], function($, _, mediator, View, CollectionView, utils,

    templateTable,
    templateTableRow
) {
    'use strict';

    var TableRowView = View.extend({
        template: templateTableRow,
        tagName: 'tr',
        listen: {
            'change:selected model': 'render'
        },

        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            this.delegate('click', '.table-repeat-request-check input', this.onClickCheck);
        },

        render: function() {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);

            this.$('.table-repeat-request-comment i').tooltip({ container: 'body', placement: 'bottom' });
        },

        onClickCheck: function() {
            this.model.set('selected', !this.model.get('selected'));
        },

        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        },

        destroyTooltip: function() {
            this.$('.table-repeat-request-comment i').tooltip('destroy');
        }
    });

    var TableView = CollectionView.extend({
        autoRender: true,
        animationDuration: 0,
        listSelector: 'tbody',
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        template: templateTable,
        region: 'repeat-table',
        itemView: TableRowView,
        render: function() {
            CollectionView.prototype.render.apply(this, arguments);
            this.$('tbody').off('scroll').on('scroll', _.bind(function() { this.$('.table-repeat-request-comment').popover('destroy'); }, this));
        }
    });

    return TableView;
});

